import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import {
  EuropeAssistanceCollisioneInfoModalStyles, CloseButton, LeftSide, ModalBody, ModalContent, ModalHeader,
  TextContainer,
  TitleBox,
} from './EuropeAssistanceCollisioneModal.styles';
import infoIcon from '../../../../assets/redesign_icons/info-icon.svg';

export const MY_RESCUE_INFO = {
  assistenza_stradale: {
    title: 'Assistenza Stradale (Rescue 300)',
    cosaIncludeTitle: 'Cosa include',
    cosaInclude: [
      'Guasto meccanico, sinistro stradale, furto, foratura/scoppio pneumatici, esaurimento batteria, mancato avviamento, gelo/errata fornitura carburante, montaggio catene da neve, smarrimento chiavi, atti vandalici, eventi atmosferici (esclusa grandine)',
      'Soccorso e traino sul posto, entro 50 km, verso il centro assistenza più vicino o indicato',
      'Ricovero garantito presso il centro assistenza disponibile',
      'Sostituzione pneumatico: costo manodopera incluso (materiali esclusi)',
    ],
    numeroInterventiTitle: 'Numero interventi',
    numeroInterventi: [
      'Soccorso di primo intervento: 1 ogni 6 mesi oppure 3 all\'anno (a seconda dell\'attivazione)',
      'Spostamento veicolo (solo Italia): 1 ogni 6 mesi oppure 1 all\'anno',
      'Rimessa in carreggiata: max 1 ogni 6 mesi oppure 1 all\'anno',
      'Tra due richieste devono passare almeno 48 ore',
    ],
    massimaliTitle: 'Massimali',
    massimali: [
      { label: 'Rimessa in carreggiata', value: '600,00 € (IVA inclusa)' },
      { label: 'Traino tramite altro operatore (Italia)', value: '150,00 € (IVA inclusa)' },
      { label: 'Traino tramite altro operatore (Estero)', value: '200,00 € (IVA inclusa)' },
      { label: 'Auto sostitutiva', value: '30,00 €/giorno (IVA inclusa), max 5 giorni' },
      { label: 'Rientro viaggiatori', value: 'fino a 300,00 € (IVA inclusa)' },
      { label: 'Pernottamento in hotel', value: '70,00 €/notte (IVA inclusa), max 300,00 € totali' },
    ],
    cosaEscludeTitle: 'Cosa esclude',
    cosaEsclude: [
      'Veicoli con targa prova, targa estera, da gara, a noleggio (senza conducente o lungo termine), auto d\'epoca, o con portata superiore a 35 quintali',
      'Zone non raggiungibili dal mezzo di soccorso, fermo amministrativo, sequestro o deposito giudiziario del veicolo',
      'Assenza di RC Auto obbligatoria',
      'Competizioni motoristiche o gare',
      'Spese per pezzi di ricambio e riparazione, mezzi eccezionali',
      'Danni da grandine',
      'Guida senza abilitazione, in stato di ebbrezza o sotto l\'effetto di stupefacenti',
      'Guerra, terremoti, calamità naturali, scioperi, rivoluzioni, sommosse, terrorismo, vandalismo, dolo del contraente',
    ],
  },
  tutela_legale: {
    title: 'Tutela Legale',
    massimaleTitle: 'Massimale',
    massimale: '10.000,00 € per sinistro',
    sublimitsTitle: 'Sottolimiti',
    sublimits: [
      'Legale domiciliatario (solo fase giudiziale): fino a 2.000,00 €',
    ],
    cosaIncludeTitle: 'Cosa include',
    cosaInclude: [
      'Spese legali sostenute dall\'avvocato dell\'assicurato, comprese quelle del legale domiciliatario',
      'Spese legali della controparte in caso di soccombenza o transazione',
      'Spese processuali (contributo unificato, registrazione atti giudiziari, spese di giustizia nel processo penale)',
      'Spese peritali e investigative (consulenti/periti nominati dall\'assicurato o dal giudice)',
      'Procedure alternative di risoluzione (negoziazione assistita, mediazione civile, arbitrato)',
    ],
    cosaEscludeTitle: 'Cosa esclude',
    cosaEsclude: [
      'Atti dolosi dell\'assicurato',
      'Tumulti, guerre, catastrofi naturali, scioperi, sostanze radioattive',
      'Materia fiscale, tributaria, diritto di famiglia, successioni, danni extracontrattuali',
      'Ritiro/sospensione patente non legati alla circolazione stradale',
      'Controversie con valore in lite inferiore a 350,00 €',
      'Controversie contro Tutela Legale Spa',
      'Conducente non abilitato o veicolo senza RC Auto obbligatoria',
    ],
  },
  collisione: {
    title: 'Collisione (Collision Rescue Greenia)',
    massimaleTitle: 'Massimale',
    massimale: '1.500,00 € (IVA inclusa)',
    massimaleNote: 'Il contributo non può superare il valore commerciale del veicolo al momento del sinistro. In caso di responsabilità parziale, il contributo è ridotto in proporzione alla % di responsabilità riconosciuta (es. 50% responsabilità → 50% del massimale).',
    numeroInterventiTitle: 'Numero interventi',
    numeroInterventi: ['1 per l\'intera durata del contratto'],
    cosaIncludeTitle: 'Cosa include',
    cosaInclude: [
      'Collisione diretta tra il veicolo assicurato e un altro veicolo',
      'Contributo per la riparazione, da effettuarsi presso il Centro Assistenza convenzionato (entro 50 km) o, previa autorizzazione, presso un centro di fiducia',
    ],
    cosaEscludeTitle: 'Cosa esclude',
    cosaEsclude: [
      'Veicoli con targa prova, targa estera, da gara, a noleggio (breve o lungo termine), adibiti a trasporto pubblico, auto d\'epoca, o con portata superiore a 35 quintali',
      'Danni da grandine',
      'Sinistri che non coinvolgono un altro veicolo (es. uscita di strada, ribaltamento)',
      'Sinistri attribuibili a colpa della controparte o ad ignoti',
      'Accessori/optional non compresi nell\'allestimento originario',
      'Sinistri avvenuti fuori dalla rete stradale pubblica/autostradale o in area/parcheggio privato o condominiale',
      'Dolo o colpa grave del contraente/conducente',
      'Atti di guerra, terrorismo, scioperi',
      'Gare o competizioni automobilistiche',
      'Guida senza patente, in stato di ebbrezza o sotto l\'effetto di stupefacenti',
    ],
  },
};

function MyRescueInfoModal({ quoteType, setShowModal }) {
  const info = MY_RESCUE_INFO[quoteType];
  if (!info) return null;

  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <EuropeAssistanceCollisioneInfoModalStyles>
      <ModalBody>
        <ModalHeader>
          <LeftSide>
            <TextContainer>
              <TitleBox>
                <img src={infoIcon} alt="" />
                <h3>{info.title}</h3>
              </TitleBox>
              <p>
                Qui puoi controllare le informazioni su questa offerta.
              </p>
            </TextContainer>
          </LeftSide>
          <CloseButton onClick={() => closeModal()} aria-label="Chiudi">
            <FontAwesomeIcon icon={faTimes} />
          </CloseButton>
        </ModalHeader>
        <ModalContent>
          <div className="card-extra-information">
            {info.massimale && (
              <>
                <h3>{info.massimaleTitle}</h3>
                <p>{info.massimale}</p>
                {info.massimaleNote && <p>{info.massimaleNote}</p>}
              </>
            )}

            {info.sublimits && (
              <>
                <h3>{info.sublimitsTitle}</h3>
                <ul>
                  {info.sublimits.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </>
            )}

            {info.massimali && (
              <>
                <h3>{info.massimaliTitle}</h3>
                <ul>
                  {info.massimali.map((item, index) => (
                    <li key={index}>
                      <b>{item.label}</b>
                      {': '}
                      {item.value}
                    </li>
                  ))}
                </ul>
              </>
            )}

            {info.numeroInterventi && (
              <>
                <h3>{info.numeroInterventiTitle}</h3>
                <ul>
                  {info.numeroInterventi.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </>
            )}

            {info.cosaInclude && (
              <>
                <h3>{info.cosaIncludeTitle}</h3>
                <ul>
                  {info.cosaInclude.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </>
            )}

            {info.cosaEsclude && (
              <>
                <h3>{info.cosaEscludeTitle}</h3>
                <ul>
                  {info.cosaEsclude.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </>
            )}
          </div>
        </ModalContent>
      </ModalBody>
    </EuropeAssistanceCollisioneInfoModalStyles>
  );
}

export default MyRescueInfoModal;
